import "../../css/site.scss";

import "admin-lte/dist/img/user1-128x128.jpg";
import "admin-lte/dist/img/user3-128x128.jpg";
import "admin-lte/dist/img/user8-128x128.jpg";
import "../../images/logo.png";

import "@babel/polyfill";
import "jquery";
import "jquery-ui";
import "bootstrap/dist/js/bootstrap.bundle";
import "admin-lte/dist/js/adminlte";